export default __webpack_public_path__ + "static/media/necroticdetonation.c35b9011.png";